import { isLocalhost, isStaging, isDemo } from 'utils';

export const isDev = (): boolean => {
  return isLocalhost() || isStaging() || isDemo();
};
